'use strict';

var ProfileChartLegendController = function ProfileChartLegendController($scope) {
  $scope.isCollapsed = true;
  $scope.legendClickHandler = function (element) {
    if (element.selectable) {
      element.selected = !element.selected;
      var evtData = {
        id: element.id,
        selected: element.selected
      };
      $scope.$emit('chart-legend:legend-item-toggle', evtData);
    }
  };
  $scope.collapseIconClickedHandler = function () {
    $scope.isCollapsed = !$scope.isCollapsed;
  };
};
ProfileChartLegendController.$inject = ['$scope'];
module.exports = ProfileChartLegendController;